import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SfAccordionSummary, SfLocationLabelText } from './Filter.style';
import { FacetState } from '@coveo/headless';
import { useEffect, useState } from 'react';
import { TypographyProps } from '@mui/material/Typography';

const StudyPhaseFilter = (props: any): JSX.Element => {
  const { controller, showMoreText, showLessText, clearAllText, noFacetsText } = props;

  const [state, setState] = useState<FacetState>(controller.state);

  const onClearAll = () => {
    controller.deselectAll();
  };
  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);
  const onChange = (value: any) => {
    controller.toggleSelect(value);
  };
  return (
    <Grid item sx={{ marginTop: '1rem' }}>
      <Accordion disableGutters defaultExpanded={false}>
        <SfAccordionSummary
          expandIcon={
            <ChevronRightIcon
              sx={{
                color: (theme: any) => theme.palette.neutral8.main,
                height: '32px',
                width: '32px',
              }}
            />
          }
          aria-controls="study-phase-content"
          id="study-phase-header"
        >
          <SfLocationLabelText>{props?.fields?.heading?.value}</SfLocationLabelText>
        </SfAccordionSummary>

        {state.hasActiveValues && (
          <Typography
            onClick={onClearAll}
            component="div"
            color="error.main"
            sx={{
              marginLeft: '16px',
              '&:hover': { cursor: 'pointer', textDecoration: 'underline' },
            }}
            {...({} as TypographyProps<'div'>)} // ✅ This ensures correct type inference
          >
            {clearAllText}
          </Typography>
        )}

        <AccordionDetails>
          {state && state.values.length ? (
            state?.values?.map((value) => (
              <div key={value?.value}>
                <FormControlLabel
                  sx={{ color: (theme) => theme.palette.neutral9.main }}
                  key={value.value}
                  label={`${value.value} (${value.numberOfResults} results)`}
                  control={
                    <Checkbox
                      checked={controller.isValueSelected(value)}
                      onChange={() => onChange(value)}
                      disabled={state.isLoading}
                    />
                  }
                />
              </div>
            ))
          ) : (
            <span>{noFacetsText}</span>
          )}
        </AccordionDetails>
        {state.canShowMoreValues && (
          <Button onClick={() => controller.showMoreValues()}>{showMoreText}</Button>
        )}
        {state.canShowLessValues && (
          <Button onClick={() => controller.showLessValues()}>{showLessText}</Button>
        )}
      </Accordion>
    </Grid>
  );
};

export default StudyPhaseFilter;
